import React, { useState, useCallback } from 'react';

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

export default function QuizAliasAuth(props) {

  const { onAuthProvided, authErrorList, authCount, defaultAlias } = props;

  const [alias, setAlias] = useState(defaultAlias || "");

  const onSubmit = useCallback(evt => {

    evt.preventDefault();
    onAuthProvided({ alias });

  }, [alias, onAuthProvided])

  return (
    <div id="quizAliasAuth" className="bg-purple h-100">
      <Container fluid className="d-flex align-items-center justify-content-center h-100">
        <Row> 
          <Col>

            <form onSubmit={onSubmit}>

              <h5>Ditt alias</h5>
              <input type="text" 
                className="form-control mb-2" 
                value={alias}
                onChange={ev => setAlias(ev.target.value) } 
              />

              <i>OBS! Ditt alias kommer att sparas.</i> 
              <br/>

              <Button type="submit" className="mt-3" variant="quizPrimary">
                Klar (gå vidare)
              </Button>

              {authCount > 0 && authErrorList && authErrorList.length > 0 ? 
                <div className="mt-2 text-quizError errorMsg">
                  {authErrorList.map((err, idx) => 
                    {
                      switch(err.errorCode)
                      {
                        case "QUIZ_FULL":
                          return <div key={idx}>Quizzet har nått max antal deltagare.</div>;
                        default:
                        case "ALIAS_REQUIRED":
                          return <div key={idx}>Måste ange ett alias</div>;
                      }
                    }
                  )}
                </div> : null
              }

            </form>

          </Col>
        </Row>
      </Container>
    </div>
  );
}
